import { useEffect } from "react";

import { useUserProfileContext } from "@/contexts/UserProfileContext";
import { PRACTITIONER } from "@/core/constants";
import { CREATE_PRACTITIONER_PROFILE_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";

import buildPractitionerApplicationMutationInput from "../buildPractitionerApplicationMutationInput";
import Common from "./CommonForm";

export default function LoggedInForm({ setFormSubmitted }) {
  const { patientProfile } = useUserProfileContext();

  const api = useDjangoGraphqlForm({
    transformer: buildPractitionerApplicationMutationInput,
    mutation: CREATE_PRACTITIONER_PROFILE_MUTATION,
    mutationName: "createPractitionerProfileMutation",
    defaultValues: {
      tier: PRACTITIONER,
      firstName: patientProfile?.user?.firstName || "",
      lastName: patientProfile?.user?.lastName || "",
      email: patientProfile?.user?.email || "",
      dateOfBirth: patientProfile?.dateOfBirth || "",
      gender: patientProfile?.gender || "",
      practitionerType: "",
      professionalBodies: [],
      documents: [],
      phoneNumber: "",
      jobRole: "",
      businessName: "",
      specialisms: [],
      businessLocationCity: "",
      businessCountry: "",
      clientsPerMonth: "",
      orderTestingTimeline: "",
      expectedTestsPerMonth: "",
      supplementRecommendationMethod: "",
      supplementProvider: "",
      insuranceProvider: "",
      insurancePolicyNumber: "",
      insuranceExpiryDate: "",
      insuranceEvidence: null,
      acceptTerms: false
    },
    handleSuccess: () => {
      setFormSubmitted(true);
    }
  });

  useEffect(() => {
    if (patientProfile) {
      api.methods.reset({
        tier: PRACTITIONER,
        firstName: patientProfile?.user?.firstName || "",
        lastName: patientProfile?.user?.lastName || "",
        email: patientProfile?.user?.email || "",
        dateOfBirth: patientProfile?.dateOfBirth || "",
        gender: patientProfile?.gender || "",
        practitionerType: "",
        professionalBodies: [],
        documents: [],
        phoneNumber: "",
        jobRole: "",
        businessName: "",
        specialisms: [],
        businessLocationCity: "",
        businessCountry: "",
        clientsPerMonth: "",
        orderTestingTimeline: "",
        expectedTestsPerMonth: "",
        supplementRecommendationMethod: "",
        supplementProvider: "",
        insuranceProvider: "",
        insurancePolicyNumber: "",
        insuranceExpiryDate: "",
        insuranceEvidence: null,
        acceptTerms: false
      });
    }
  }, [patientProfile]);

  return (
    <Common
      api={api}
      readOnlyFields={["firstName", "lastName", "email", "gender", "dateOfBirth"]}
    />
  );
}
